export default function getImageLink(img: string | null) {
  if (!img) return undefined;
  return `https://admin-school.azno.co/images/${img}`;
}
